exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Reoz{color:#000;display:inline-block;font-size:14px;padding-left:5px;text-transform:uppercase;font-weight:700;text-align:center;line-height:14px}.ZYuco{height:100%;max-height:30px;width:auto}", ""]);

// exports
exports.locals = {
	"tooltipTitle": "_2Reoz",
	"tooltipIcon": "ZYuco"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/WarrantyLogo/WarrantyLogo.css
// module id = 1926
// module chunks = 18 19 31 32 37